import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronRight, Search, Bell, Settings, Menu } from 'lucide-react';
import SearchModal from './SearchModal';

const ROUTE_CRUMBS = {
  '/':                  ['Overview', 'Dashboard'],
  '/metrics':           ['Overview', 'Dashboard'],
  '/units':             ['Organization', 'Units'],
  '/unit-management':   ['Organization', 'Unit Management'],
  '/towns':             ['Organization', 'Towns'],
  '/staff':             ['People', 'Staff'],
  '/area-coordinators': ['People', 'Area Coordinators'],
  '/audit-log':         ['Compliance', 'Activity Feed'],
  '/membership-audits': ['Compliance', 'Membership Audits'],
  '/admin/users':       ['Admin', 'Users'],
  '/admin/reports':     ['Admin', 'Reports'],
  '/admin/assignments': ['Admin', 'Mass Assignment'],
};

function getCrumbs(pathname) {
  if (ROUTE_CRUMBS[pathname]) return ROUTE_CRUMBS[pathname];
  if (pathname.startsWith('/units/') || pathname.startsWith('/unit-info/'))
    return ['Organization', 'Units', 'Detail'];
  if (pathname.startsWith('/town/'))
    return ['Organization', 'Towns', 'Detail'];
  if (pathname.startsWith('/employee/'))
    return ['People', 'Staff', 'Employee'];
  return ['Datahouse'];
}

function Topbar({ onMenu }) {
  const location = useLocation();
  const crumbs = getCrumbs(location.pathname);
  const [searchOpen, setSearchOpen] = useState(false);

  // Cmd+K / Ctrl+K global shortcut
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <header className="topbar">
        <button
          className="mobile-menu-btn"
          type="button"
          onClick={onMenu}
          aria-label="Open navigation menu"
        >
          <Menu size={20} />
        </button>
        <div className="breadcrumb">
          {crumbs.map((c, i) => (
            <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              {i > 0 && <ChevronRight size={12} className="sep" />}
              {i === crumbs.length - 1 ? <b>{c}</b> : <span>{c}</span>}
            </span>
          ))}
        </div>

        {/* Clicking the search bar opens the modal */}
        <div
          className="topbar-search"
          role="button"
          tabIndex={0}
          onClick={() => setSearchOpen(true)}
          onKeyDown={(e) => e.key === 'Enter' && setSearchOpen(true)}
          style={{ cursor: 'pointer' }}
        >
          <Search size={14} className="ic" />
          <input
            type="text"
            placeholder="Search units, towns, staff…"
            readOnly
            style={{ cursor: 'pointer', pointerEvents: 'none' }}
          />
          <kbd>⌘K</kbd>
        </div>

        <div className="topbar-spacer" />
        <div className="topbar-actions">
          <button
            className="btn-icon mobile-search-btn"
            title="Search"
            aria-label="Search"
            onClick={() => setSearchOpen(true)}
          >
            <Search size={18} />
          </button>
          <button className="btn-icon" title="Notifications">
            <Bell size={18} />
          </button>
          <button className="btn-icon" title="Settings">
            <Settings size={18} />
          </button>
        </div>
      </header>

      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}

export default Topbar;
